import { FC } from 'react'
import styles from 'components/features/pfm/CategoriesMenu/Category.styl'
import { CategoryId, Category as CategoryType } from 'interfaces/meta'
import cn from 'classnames'

type CategoryProps = {
  selectedId: CategoryId
  category: CategoryType
  onSelect?: (selectedId: CategoryId) => void
}
export const Category: FC<CategoryProps> = (props) => {
  const { selectedId, category, onSelect } = props

  const { id, value } = category
  const className = cn(styles.option, {
    [styles.selectedOption]: id === selectedId,
  })
  const handleClick = onSelect ? () => onSelect(id) : undefined

  return (
    <div
      className={ className }
      onClick={ handleClick }
    >
      <a className={ styles.optionCaption } data-option-id={ id }>{ value }</a>
    </div>
  )
}
